import React from 'react';
import { useTranslation } from 'context/LanguageContext';

const QuantitySelector = ({ quantity, setQuantity, maxQuantity, pricePerUnit, formatPrice }) => {
  const hasMaxQuantity = Number.isFinite(maxQuantity);

  const handleQuantityChange = (action) => {
    if (action === 'increase' && (!hasMaxQuantity || quantity < maxQuantity)) {
      setQuantity(quantity + 1);
    } else if (action === 'decrease' && quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const { t } = useTranslation();

  return (
    <div className="mb-4">
      <label className="text-xs font-medium text-gray-700 mb-1.5 block">
        {t("quantity")}
      </label>
      <div className="flex items-center gap-2">
        <button
          onClick={() => handleQuantityChange('decrease')}
          disabled={quantity <= 1}
          className="w-8 h-8 rounded-lg border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm"
        >
          -
        </button>
        <input
          type="number"
          value={quantity}
          readOnly
          className="w-16 h-8 text-center border border-gray-300 rounded-lg font-medium text-sm"
        />
        <button
          onClick={() => handleQuantityChange('increase')}
          disabled={hasMaxQuantity && quantity >= maxQuantity}
          className="w-8 h-8 rounded-lg border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm"
        >
          +
        </button>
        <span className="text-xs text-gray-600 ml-1">
          Total: {formatPrice(pricePerUnit * quantity)}
        </span>
      </div>
    </div>
  );
};

export default QuantitySelector;
